export default __webpack_public_path__ + "static/media/household-floor-plan-1-2.1dfbf66b.png";